export const TOKEN_KEY = 'accessToken';
export const USER_KEY = 'didoReducer';
export const UNAUTHORIZED_HTTP_CODE = 401;
export const LOAD_REPOS = 'LOAD_REPOS';
export const LOAD_REPOS_SUCCESS = 'LOAD_REPOS_SUCCESS';
export const LOAD_REPOS_ERROR = 'LOAD_REPOS_ERROR';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const SNACK_ERROR = { variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } };
export const SNACK_SUCCESS = { variant: 'success', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } };
export const SNACK_WARNING = { variant: 'warning', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } };
export const FREEMIUM_SIGN_UP_TEXT = 'Freemium_SignUp_Text'
export const NEW_INFO_PAGE_URL = '/newpage';
export const MESSAGE_TYPE_ASSISTANT = 0;
export const MESSAGE_TYPE_HUMAN = 1;
// mirrors CareOrigin on the backend; sent and received as a number
export const CARE_ORIGIN_FORMEEL = 0;
export const CARE_ORIGIN_VRIJWILLIGER = 1;
export const CARE_ORIGIN_FAMILIE = 2;
export const CARE_ORIGIN_MANTELZORGER = 3;
export const CARE_ORIGIN_SOCIAAL_NETWERK = 4;
export const CARE_ORIGIN_OPTIONS = [
    { value: CARE_ORIGIN_FORMEEL, label: 'Formele zorg' },
    { value: CARE_ORIGIN_VRIJWILLIGER, label: 'Vrijwilliger' },
    { value: CARE_ORIGIN_FAMILIE, label: 'Familie' },
    { value: CARE_ORIGIN_MANTELZORGER, label: 'Mantelzorger' },
    { value: CARE_ORIGIN_SOCIAAL_NETWERK, label: 'Sociaal netwerk' },
];
// mirrors CareComponent on the backend; sent and received as a number
export const CARE_COMPONENT_OVERIG = 0;
export const CARE_COMPONENT_ZORG = 1;
export const CARE_COMPONENT_PERSOONSGEBONDEN_WELZIJN = 2;
export const CARE_COMPONENT_DAGSTRUCTUUR = 3;
export const CARE_COMPONENT_OPTIONS = [
    { value: CARE_COMPONENT_OVERIG, label: 'Overig' },
    { value: CARE_COMPONENT_ZORG, label: 'Zorg' },
    { value: CARE_COMPONENT_PERSOONSGEBONDEN_WELZIJN, label: 'Persoonsgebonden welzijn' },
    { value: CARE_COMPONENT_DAGSTRUCTUUR, label: 'Dagstructuur' },
];
export const CHAT_TEMPLATE_KEY = 'PromptTemplate';
export const CHAT_TEMPERATURE = 'ChatTemperature';
export const CHAT_MAX_TOKENS = 'ChatMaxTokens';